import { Store } from "../utils/store";

export const SETTINGS = {
  showOnClick: false,
  pessimisticSave: true,
  verticalTabs: false,
  customAuthToken: "",
  "ENV.API_URL": "",
  "ENV.KEYCLOAK_CONFIG.url": "",
  "ENV.KEYCLOAK_CONFIG.clientId": "",
  "json.max_lines": 10,
  listPageSize: 25,
  menuGroups: ["", "legacy"],
  resetStorage: () => {
    console.log("Reseting storage");
    Store.flip("RaStore.version");
    window.location.reload();
  },
};
